import request from "./clientsApi";
import { API_ROUTES } from "../config/baseURL";

export const apiGetRPYM = async (Subgrupo, Cons) => {
  const res = await request(API_ROUTES.getRPYM(Subgrupo, Cons), { method: "GET" });
  return res.json();
};

export const apiGetRPYMById = async (id) => {
  const res = await request(API_ROUTES.getRPYMById(id), { method: "GET" });
  return res.json();
};

export const apiSaveRPYM = async (payload) => {
  const isUpdate = !!payload.id;
  const res = await request(API_ROUTES.saveRoutesPYM, {
    method: isUpdate ? "PUT" : "POST",
    body: JSON.stringify(payload),
  });
  return res.json();
};
